import React from "react";
import * as dayjs from "dayjs";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import { Button } from "@material-ui/core";
import Table, { getTextLabels } from "components/Form/Table";
import CardBox from "components/CardBox/index";

const QarzibaTable = ({
    data,
    handleOpenCRU,
    setCurrentRowObj,
    readOnly,
    handleOpenDel,
    DiagnosticCodeCIEList
}) => {
    const options = {
        filter: false,
        filterType: "dropdown",
        download: false,
        print: false,
        viewColumns: false,
        selectableRows: "none",
        search: false,
        textLabels: getTextLabels(),
    };

    const handleClick = (obj) => {
        handleOpenCRU();
        setCurrentRowObj(!obj ? null : obj);
    };

    const getRowObj = (tableMeta) => tableMeta.tableData[tableMeta.rowIndex];

    const getNameById = (list, value) => {
        if (value === null || value === undefined) return "";
        const item = list.find(x => String(x.id) === String(value));
        return item ? item.name : String(value);
    };

    const columns = [
        
        {
            name: "ciE10_11",
            label: IntlGetText("sylvant.cie10"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => {
                    const rowObj = getRowObj(tableMeta);
                    const cie10Name = getNameById(DiagnosticCodeCIEList, value);
                    if (value === 16 && rowObj.cie10OtherDescription) {
                        return `${cie10Name} - ${rowObj.cie10OtherDescription}`;
                    }
                    return cie10Name;
                },
            },
        },
        {
            name: "relapseDisease",
            label: IntlGetText("qarziba.relapseDisease"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => {
                    if (value === true) return "Sí";
                    if (value === false) return "No";
                    return "";
                },
            },
        },
        {
            name: "vialsPerCycle",
            label: IntlGetText("qarziba.vialsPerCycle"),
            options: { filter: false, sort: false },
        },
        {
            name: "totalCyclesFormulated",
            label: IntlGetText("qarziba.totalCyclesFormulated"),
            options: { filter: false, sort: false },
        },
        {
            name: "totalFormulatedVials",
            label: IntlGetText("qarziba.totalFormulatedVials"),
            options: { filter: false, sort: false },
        },
        {
            name: "totalVialsApproved",
            label: IntlGetText("qarziba.totalVialsApproved"),
            options: { filter: false, sort: false },
        },
        {
            name: "totalAppliedVials",
            label: IntlGetText("qarziba.totalAppliedVials"),
            options: { filter: false, sort: false },
        },
        {
            name: "purchasedVials",
            label: IntlGetText("qarziba.purchasedVials"),
            options: { filter: false, sort: false },
        },
        {
            name: "purchasedNotApplied",
            label: IntlGetText("qarziba.purchasedNotApplied"),
            options: { filter: false, sort: false },
        },
        {
            name: "unusedVials",
            label: IntlGetText("qarziba.unusedVials"),
            options: { filter: false, sort: false },
        },
        {
            name: "importNotAvailable",
            label: IntlGetText("vitalNotAvailable.importNotAvailable"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => {
                    if (value === true) return "Sí";
                    if (value === false) return "No";
                    return "";
                },
            },
        },
        {
            name: "submissionDate",
            label: IntlGetText("vitalNotAvailable.submissionDate"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) =>
                    value ? dayjs(value).format("YYYY/MM/DD") : "",
            },
        },
        {
            name: "autoDate",
            label: IntlGetText("vitalNotAvailable.autoDate"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) =>
                    value ? dayjs(value).format("YYYY/MM/DD") : "",
            },
        },
        {
            name: "approvalDate",
            label: IntlGetText("vitalNotAvailable.approvalDate"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) =>
                    value ? dayjs(value).format("YYYY/MM/DD") : "",
            },
        },
        {
            name: "authorizationNumber",
            label: IntlGetText("vitalNotAvailable.authorizationNumber"),
            options: { filter: false, sort: false },
        },
        {
            name: "awardedTo",
            label: IntlGetText("vitalNotAvailable.awardedTo"),
            options: { filter: false, sort: false },
        },
        {
            name: "startDateTreatment",
            label: IntlGetText("vitalNotAvailable.startDateTreatment"),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) =>
                    value ? dayjs(value).format("YYYY/MM/DD") : "",
            },
        },
        {
            name: "actions",
            label: <IntlMessages id="core.actions" />,
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => {
                    const rowObj = getRowObj(tableMeta);
                    return (
                        <React.Fragment>
                            <Button
                                onClick={() => handleClick(rowObj)}
                                variant="contained"
                                className="jr-btn jr-btn-xs"
                                style={{ marginRight: "5px" }}
                            >
                                <i className="zmdi zmdi-edit"></i>
                            </Button>
                            {!readOnly && (
                                <Button
                                    onClick={() => {
                                        setCurrentRowObj(rowObj);
                                        handleOpenDel();
                                    }}
                                    variant="contained"
                                    className="jr-btn jr-btn-xs"
                                >
                                    <i className="zmdi zmdi-delete"></i>
                                </Button>
                            )}
                        </React.Fragment>
                    );
                },
            },
        },
    ];

    return (
        <div className="row">
            <CardBox styleName="col-12" cardStyle="p-0 border-dialog-card">
                <Table
                    className="border-dialog-card"
                    data={data}
                    columns={columns}
                    options={options}
                />
            </CardBox>
            {!readOnly && (
                <div className="col-lg-12 col-md-12 col-xs-12 mt-4 text-center">
                    <Button
                        onClick={() => handleClick(null)}
                        variant="contained"
                        color="primary"
                    >
                        <IntlMessages id="core.add" />
                    </Button>
                </div>
            )}
        </div>
    );
};

export default QarzibaTable;